var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from "react";
import { InputLabel, Select, MenuItem, Button, Grid, Typography, } from "@mui/material";
import { useState, useEffect } from "react";
import { useForm, FormProvider } from "react-hook-form";
import FormInput from "./FormInput";
import { commerce } from "../../lib/commerce";
import { Link } from "react-router-dom";
/* const AddressFormSchema = z.object({
  firstName: z.string({
    required_error: "First name is required",
    invalid_type_error: "Please enter a valid first name",
  }),
  lastName: z.string({
    required_error: "Last name is required",
    invalid_type_error: "Please enter a valid last name",
  }),
  propertyNumber: z.string({
    required_error: "A flat/house number is required",
    invalid_type_error: "Please enter a flat/house number",
  }),
  addressLine1: z.string({
    required_error: "An address line is required",
    invalid_type_error: "Please enter a valid address",
  }),
  town: z.string({
    required_error: "Town is required",
    invalid_type_error: "Please enter a valid town",
  }),
  ZipPostCode: z.string({
    required_error: "A zip/postal code is required",
    invalid_type_error: "Please enter a valid zip/postal code",
  }),
  emailAddress: z
    .string({
      required_error: "An email address is required",
      invalid_type_error: "Please enter a valid email address",
    })
    .email(),
  cellNumber: z.string({
    required_error: "A cell number is required",
    invalid_type_error: "Please enter a valid cell number",
  }),
}); */
var AddressForm = function (_a) {
    var checkoutToken = _a.checkoutToken, next = _a.next;
    var methods = useForm({
        defaultValues: {
            firstName: "",
            lastName: "",
            propertyNumber: "",
            addressLine1: "",
            town: "",
            ZipPostCode: "",
            emailAddress: "",
            cellNumber: "",
        },
    });
    var _b = useState([]), shippingCountries = _b[0], setShippingCountries = _b[1];
    var _c = useState(""), shippingCountry = _c[0], setShippingCountry = _c[1];
    var _d = useState([]), shippingRegions = _d[0], setShippingRegions = _d[1];
    var _e = useState(""), shippingRegion = _e[0], setShippingRegion = _e[1];
    var _f = useState([]), shippingOptions = _f[0], setShippingOptions = _f[1];
    var _g = useState(""), shippingOption = _g[0], setShippingOption = _g[1];
    var countries = Object.entries(shippingCountries).map(function (_a) {
        var code = _a[0], name = _a[1];
        return ({
            id: code,
            label: name,
        });
    });
    var subdivisions = Object.entries(shippingRegions).map(function (_a) {
        var code = _a[0], name = _a[1];
        return ({
            id: code,
            label: name,
        });
    });
    var options = shippingOptions.map(function (sO) { return ({
        id: sO.id,
        label: "".concat(sO.description, " - (").concat(sO.price.formatted_with_symbol, ")"),
    }); });
    var fetchShippingCountries = function (checkoutTokenID) { return __awaiter(void 0, void 0, void 0, function () {
        var countries;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, commerce.services.localeListShippingCountries(checkoutTokenID)];
                case 1:
                    countries = (_a.sent()).countries;
                    setShippingCountries(countries);
                    setShippingCountry(Object.keys(countries)[0]);
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchCountryRegions = function (countryCode) { return __awaiter(void 0, void 0, void 0, function () {
        var subdivisions;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, commerce.services.localeListSubdivisions(countryCode)];
                case 1:
                    subdivisions = (_a.sent()).subdivisions;
                    setShippingRegions(subdivisions);
                    setShippingRegion(Object.keys(subdivisions)[0]);
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchShippingOptions = function (checkoutTokenID, country, region) {
        if (region === void 0) { region = null; }
        return __awaiter(void 0, void 0, void 0, function () {
            var options;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, commerce.checkout.getShippingOptions(checkoutTokenID, { country: country, region: region })];
                    case 1:
                        options = _a.sent();
                        setShippingOption(options[0].id);
                        setShippingOptions(options);
                        return [2 /*return*/];
                }
            });
        });
    };
    useEffect(function () {
        fetchShippingCountries(checkoutToken === null || checkoutToken === void 0 ? void 0 : checkoutToken.id);
    }, []);
    useEffect(function () {
        if (shippingCountry)
            fetchCountryRegions(shippingCountry);
    }, [shippingCountry]);
    useEffect(function () {
        if (shippingRegion)
            fetchShippingOptions(checkoutToken === null || checkoutToken === void 0 ? void 0 : checkoutToken.id, shippingCountry, shippingRegion);
    }, [shippingRegion]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography, { variant: "h6", gutterBottom: true }, "Shipping address"),
        React.createElement(FormProvider, __assign({}, methods),
            React.createElement("form", { onSubmit: methods.handleSubmit(function (data) {
                    /* const validatedAddressData = AddressFormSchema.safeParse(data);
        
                    if (!validatedAddressData.success) {
                      console.error(validatedAddressData.error);
                      return;
                    } */
                    next(__assign(__assign({}, data), { shippingCountry: shippingCountry, shippingSubdivision: shippingRegion, shippingRegion: shippingRegion, shippingOption: shippingOption }));
                }) },
                React.createElement(Grid, { container: true, spacing: 3 },
                    React.createElement(FormInput, { name: "firstName", label: "First Name" }),
                    React.createElement(FormInput, { name: "lastName", label: "Last Name" }),
                    React.createElement(FormInput, { name: "propertyNumber", label: "Flat/House No." }),
                    React.createElement(FormInput, { name: "addressLine1", label: "Address Line 1" }),
                    React.createElement(FormInput, { name: "town", label: "Town/City" }),
                    React.createElement(FormInput, { name: "ZipPostCode", label: "ZIP/Post Code" }),
                    React.createElement(FormInput, { name: "emailAddress", label: "Email Address" }),
                    React.createElement(FormInput, { name: "cellNumber", label: "Cell / Phone Number" }),
                    React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                        React.createElement(InputLabel, null, "Shipping Country"),
                        React.createElement(Select, { value: shippingCountry, fullWidth: true, onChange: function (e) { return setShippingCountry(e.target.value); } },
                            countries.map(function (countries) { return (React.createElement(MenuItem, { key: countries.id, value: countries.id }, countries.label)); }),
                            ";")),
                    React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                        React.createElement(InputLabel, null, "Shipping Region"),
                        React.createElement(Select, { value: shippingRegion, fullWidth: true, onChange: function (e) { return setShippingRegion(e.target.value); } },
                            subdivisions.map(function (subdivisions) { return (React.createElement(MenuItem, { key: subdivisions.id, value: subdivisions.id }, subdivisions.label)); }),
                            ";")),
                    React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                        React.createElement(InputLabel, null, "Shipping Options"),
                        React.createElement(Select, { value: shippingOption, fullWidth: true, onChange: function (e) { return setShippingOption(e.target.value); } }, options.map(function (option) { return (React.createElement(MenuItem, { key: option.id, value: option.id }, option.label)); })))),
                React.createElement("br", null),
                React.createElement("div", { style: { display: "flex", justifyContent: "space-between" } },
                    React.createElement(Button, { component: Link, to: "/cart", variant: "outlined" }, "Back To Cart"),
                    React.createElement(Button, { type: "submit", color: "primary", variant: "contained" }, "Proceed To Payment"))))));
};
export default AddressForm;
